document.addEventListener('DOMContentLoaded', () => {
  const navLinks = [...document.querySelectorAll('.faq-page__nav a[href^="#"]')];

  if (navLinks.length === 0) return;

  const getTarget = (hash) => {
    if (!hash || hash.charAt(0) !== '#') return null;

    return document.getElementById(decodeURIComponent(hash.slice(1)));
  };

  const getStickyOffset = () => {
    const header = document.querySelector('.shopify-section-group-header-group, .shopify-section-header, header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    return headerHeight + 24;
  };

  const setActiveLink = (hash) => {
    navLinks.forEach((link) => {
      const isActive = link.getAttribute('href') === hash;

      link.classList.toggle('is-active', isActive);
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const scrollToTarget = (target, behavior = 'smooth') => {
    if (!target) return;

    const safeTop = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset());

    if (behavior === 'smooth' && window.scrollY < 5 && safeTop > 5) {
      const root = document.documentElement;
      const previousScrollBehavior = root.style.scrollBehavior;

      root.style.scrollBehavior = 'auto';
      window.scrollTo({ top: 6, behavior: 'auto' });

      window.setTimeout(() => {
        root.style.scrollBehavior = previousScrollBehavior;
        window.scrollTo({ top: safeTop, behavior: 'smooth' });
      }, 0);

      return;
    }

    window.scrollTo({ top: safeTop, behavior });
  };

  const scrollToHash = (hash, behavior = 'smooth') => {
    const target = getTarget(hash);

    if (!target) return;

    const baseUrl = `${window.location.pathname}${window.location.search}`;

    if (window.location.hash === hash) {
      history.replaceState(null, '', baseUrl);
    }

    setActiveLink(hash);
    scrollToTarget(target, behavior);
    history.pushState(null, '', hash);
  };

  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const hash = link.getAttribute('href');
      const target = getTarget(hash);

      if (!target) return;

      event.preventDefault();
      scrollToHash(hash);
    });
  });

  window.addEventListener('hashchange', () => {
    scrollToHash(window.location.hash);
  });

  if (window.location.hash) {
    const initialHash = window.location.hash;
    const target = getTarget(initialHash);

    if (target) {
      setActiveLink(initialHash);
      window.setTimeout(() => scrollToHash(initialHash), 120);
    }
  }
});
